<template>
  <!-- <div class="area-list">
    <div class="title">摊位区域列表</div>
    <div class="text">摊区数：{{treeData.length}} 摊位数：{{pointTotal}} 经营中：{{inOperation}}</div>
    <el-tree :data="treeData" :load="loadNode" :accordion="true" lazy @node-click="handleNodeClick"></el-tree>
  </div> -->
  <div class="area-list">
      <div class="title">摊位区域列表</div>
      <div class="text">摊区数：{{treeData.length}}  摊位数：{{pointTotal}}  经营中：{{inOperation}}</div>
      <template v-for="i in areaList">
        <div class="area-item">
          <div style="text-align:left;">
            {{ i.baName }}
            <br />
            {{ "【摊位："+i.total+"，在租："+i.inuse+"，空闲："+i.idle+"】" }}
          </div>
          <el-link type="primary" @click="handleItemClick(i.baNo)">查看</el-link>
        </div>
      </template>
    </div>

</template>

<script>
export default {
  name: 'BoothAreaList',
  props: {
    areaList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      pointTotal:0,
      inOperation:0,
    };
  },
  computed: {
    treeData() {
      let that = this;
      return this.areaList.map((item) => {
        that.pointTotal += Number(item.total);
        that.inOperation += Number(item.inuse);
        return {
          label: item.baName+'（摊位数：'+(item.total || 0)+' 经营中：'+(item.inuse || 0)+'）',
          baNo: item.baNo,
          type: 'area',
        };
      });
    },
  },
  methods: {
    loadNode(node, resolve) {
      if (node.level !== 1) {
        resolve([]);
        return;
      }

      this.$axios.get(`/api/biz/query/boothListByBano/${node.data.baNo}`).then((res) => {
        const data = res.data.data.map((item) => {
          return {
            label: `${item.baPoint} ${item.boothName}`,
            baNo: item.baNo,
            sortNo: item.baPoint,
            boothNo: item.boothNo,
            type: 'point',
          };
        });

        resolve(data);
      });
    },
    handleNodeClick({ type, baNo, sortNo, boothNo }) {
      const baInfo = this.areaList.find((item) => item.baNo === baNo);

      if (type === 'area') {
        this.$emit('onAreaClick', baInfo);
        return;
      }

      const pointInfo = baInfo.gdPointData.find((item) => item.sortNo === sortNo);
      this.$emit('onPointClick', baInfo, {
        ...pointInfo,
        boothNo,
      });
    },
    handleItemClick(baNo) {
      const baInfo = this.areaList.find((item) => item.baNo === baNo);
      this.$emit('onAreaClick', baInfo);
    },
  },
};
</script>

<style>
.area-list {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow-x: hidden;
  gap: 8px;
  padding: 8px;
}

.area-list .title {
  font-weight: bold;
}
.area-list .area-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #ccc;
  padding: 8px 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/BoothAreaList.vue